import * as PIXI from "pixi.js";
import {PredefinedPIXIAnchorPoint} from "../../PredefinedPIXIAnchorPoint";
import data from "../configs/data";

export class HandValueCounter extends PIXI.Container {

    private readonly VALUE_TEXT_STYLE = {
        fontSize: 21,
        fontFamily: "RobotoMedium",
        fill: "#fff",
        fontWeight: "bolder",
        strokeThickness: 2,
    };

    private valueText: PIXI.Text;

    constructor() {
        super();
        this.createAndAddBackground();
        this.createAndAddValueText();
    }

    public setValue(value: number, alternativeValue: number): void {
        let text = "";

        if (value < alternativeValue) {
            if (value <= 21) {
                text += "" + value;
            }
            if (alternativeValue < 21) {
                text += "/" + alternativeValue;
            }
            if (alternativeValue === 21) {
                text = "" + alternativeValue;
            }
        } else if (value > alternativeValue) {
            if (alternativeValue <= 21) {
                text += "" + alternativeValue;
            }
            if (value < 21) {
                text += "/" + value;
            }
            if (value === 21) {
                text = "" + value;
            }
        } else if (value === alternativeValue) {
            text = "" + value;
        }

        if (value > 21 && alternativeValue > 21) {
            if (value > alternativeValue) {
                text = "" + alternativeValue;
            } else {
                text = "" + value;
            }
        }

        this.valueText.text = text;
    }

    private createAndAddValueText(): void {
        this.valueText = new PIXI.Text("", this.VALUE_TEXT_STYLE);
        this.valueText.anchor = PredefinedPIXIAnchorPoint.CENTER;
        this.addChild(this.valueText);
    }

    private createAndAddBackground(): void {
        const background: PIXI.Sprite = PIXI.Sprite.fromImage(data.images.handValueBackground);
        background.anchor = PredefinedPIXIAnchorPoint.CENTER;
        this.addChild(background);
    }
}



// WEBPACK FOOTER //
// ./src/app/userInterface/HandValueCounter.ts